import React from 'react';
import moment from 'moment';
import { isNullOrUndefinedOrEmptyStr } from '../utilities/stringUtil';

const AgencyRegistrationApplicationHistoryText = ({ title, date }) => {
  if (isNullOrUndefinedOrEmptyStr(date)) {
    return null;
  }
  return (
    <div>{`${title}：${moment(date, 'YYYY/MM/DD HH:mm:ss').format(
      'YYYY/MM/DD HH:mm'
    )}`}</div>
  );
};

export default AgencyRegistrationApplicationHistoryText;



// WEBPACK FOOTER //
// ./src/components/AgencyRegistrationApplicationHistoryText.js